import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from 'vuex-persist';

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [new VuexPersist().plugin],
  state: {
    loggedIn: false,
    id: null,
    type: null,
    logindate: null,
    username: null,
    password: null,
    grantCount: 0
  },
  mutations: {
    login(state, userData) {
      state.loggedIn = true
      state.id = userData.id
      state.type = userData.type
      state.logindate = new Date();
      state.username = userData.username
      state.password = userData.password
      state.loggedIn = true;
    },
    logout(state) {
      state.loggedIn = false
      state.id = -1;
      state.type = ""
      state.logindate = null;
      state.username = ""
      state.password = ""
    }
  },
});
